import React, { Component } from 'react';
import MidiPads from "components/midi/MidiPads.js";
import { connect } from "react-redux";
import {ELEMENT_TO_TEXT} from 'constants/contextual-help.js';
import Keyboard from 'components/midi/Keyboard.js';
import '../../ContextualHelp.scss';

class ContextualHelpComponent extends Component {
    getContextualHelp() {
        let {contextualHelp} = this.props;
        if (contextualHelp) {
            let {element, arg} = contextualHelp;
            let x = ELEMENT_TO_TEXT[element];
            if (typeof x === "function") {
                x = x(arg);
            }
            if (x !== undefined) {
                if (!Array.isArray(x)) {
                    x = [x]; 
                }
                return x.map(
                    (doc, i) =>
                        <div key={i} className={i === 0 ? "doc-line" : "rest doc-line"}>{doc}</div>);
            } else if (element.documentation) {
                let name = element.prettyName || element.name;
                if (Array.isArray(element.documentation)) {
                    return (
                        <div>
                          {element.documentation.map(
                              (d, i) =>
                                  <div key={i} className={i === 0 ? "doc-line" : "rest doc-line"}>
                                    {i === 0 ? name + ": " + d : d}
                                  </div>)}
                        </div>
                    );
                } else {
                    return name + ": " + element.documentation;
                }
            }
        } else if (this.props.sequencerEngine !== undefined) {
            let showPads = this.props.padMappings &&
                Object.keys(this.props.padMappings).length > 0;
            
            if (showPads) {
                return (<MidiPads mini={true} sequencerEngine={this.props.sequencerEngine} keyboardEngine={this.props.sequencerEngine.keyboardEngine}/>);
            } else {
                return (
                    <Keyboard
                      {... this.props}
                      helper={true}
                      mini={true}
                      sequencerEngine={this.props.sequencerEngine}
                      keyboardEngine={this.props.sequencerEngine.keyboardEngine}/>
            );
            }

        } else {
            return '';
        }
    }

    render() {
        let className = this.props.contextualHelp === undefined ?
            'contextual-help empty' : 'contextual-help text';
        return (
            <div className={className}>
              {this.getContextualHelp()}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        contextualHelp: state.sequencer.contextualHelp,
        padMappings: state.keyboard.padMappings,
    }
};


export default connect(mapStateToProps, null)(ContextualHelpComponent);
 
